import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE } from '../api/client';

interface NewsItem { id: number; title: string; description: string; imageS3: string | null; createdAt: string; }

export default function NewsSection() {
  const { t, i18n } = useTranslation();
  const [news, setNews] = useState<NewsItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_BASE}/news`).then(res => setNews(res.data.slice(0, 3))).catch(() => {});
  }, [i18n.language]);

  const locale = i18n.language === 'en' ? 'en-US' : i18n.language === 'ky' ? 'ky-KG' : 'ru-RU';

  if (news.length === 0) return null;

  return (
    <section className="section" style={{ background: 'var(--bg)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 48, flexWrap: 'wrap', gap: 16 }}>
        <div>
          <span className="section-label">{t('news_label')}</span>
          <h2 className="section-title">{t('news_title')}</h2>
          <p className="section-subtitle" style={{ marginBottom: 0 }}>{t('news_subtitle')}</p>
        </div>
        <button onClick={() => navigate('/news')} style={{
          background: 'transparent', border: '2px solid var(--primary)',
          color: 'var(--primary)', padding: '10px 24px', borderRadius: 10,
          fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem', whiteSpace: 'nowrap',
        }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = 'var(--primary)'; (e.currentTarget as HTMLElement).style.color = '#fff'; }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'transparent'; (e.currentTarget as HTMLElement).style.color = 'var(--primary)'; }}
        >
          {t('news_all')}
        </button>
      </div>

      <div className="news-grid">
        {news.map((item, i) => (
          <article key={item.id} className="news-card reveal" style={{ animationDelay: `${i * 0.1}s` }} onClick={() => navigate(`/news/${item.id}`)}>
            <div className="news-card-img-wrap">
              {item.imageS3 ? (
                <img src={`${API_BASE}/news/media/${item.imageS3}`} alt={item.title} className="news-card-img" />
              ) : (
                <div style={{ width: '100%', height: '100%', background: `linear-gradient(135deg, hsl(${200 + i * 20},70%,88%) 0%, hsl(${200 + i * 20},60%,78%) 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem' }}>📰</div>
              )}
            </div>
            <div className="news-card-body">
              <div className="news-card-date">
                📅 {item.createdAt ? new Date(item.createdAt).toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
              </div>
              <h3 className="news-card-title">{item.title}</h3>
              <p className="news-card-desc">{item.description?.slice(0, 120)}{item.description?.length > 120 ? '...' : ''}</p>
              <div className="news-card-more">{t('news_read_more')} <span>→</span></div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
